import script from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=5aca842c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aca842c"]])

export default __exports__